import React from 'react';
interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  tone = 'dark'
}: SectionHeadingProps) {
  const isLight = tone === 'light';
  return <div className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`} data-id="element-250" data-mp="3k0yfe4cryv74">
      <p className={`text-sm font-semibold ${isLight ? 'text-amber-400' : 'text-amber-600'}`} data-id="element-251" data-mp="bk3q5rowh9bi">
        {eyebrow}
      </p>
      <h2 className={`mt-2 font-display text-3xl font-extrabold leading-[1.15] tracking-tight sm:text-4xl ${isLight ? 'text-white' : 'text-navy-900'}`} data-id="element-252" data-mp="glaypsyvacj8">
        {title}
      </h2>
      {description ? <p className={`mt-4 text-base leading-relaxed ${isLight ? 'text-white/75' : 'text-navy-900/70'}`} data-id="element-253" data-mp="uizjl0sxpjoa">
          {description}
        </p> : null}
    </div>;
}